import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { tools } from '../data/content';
export function Tools() {
  return <section id="tools" className="w-full border-t border-line bg-surface py-24 lg:py-32" data-id="element-178" data-mp="1lf400vbaft28">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-179" data-mp="17fl5x6fbai8x">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-180" data-mp="1cdmqxwwasrn1">
          <div data-id="element-181" data-mp="1cfh7z04g7zlu">
            <p className="display text-sm tracking-widest text-brand-red" data-id="element-182" data-mp="203h2mb4vsa5p">{tools.eyebrow}</p>
            <h2 className="display mt-3 max-w-xl text-[clamp(2rem,4.4vw,3.25rem)] leading-[0.98] text-cream" data-id="element-183" data-mp="244kfqpvjns38">
              {tools.heading}
            </h2>
          </div>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-184" data-mp="1qbkyojg45ptk">
          {tools.items.map(tool => <article key={tool.name} className="flex h-full flex-col border-t-2 border-line pt-6" data-id="element-185" data-mp="1va5tg3cljham">
              <h3 className="display text-2xl text-cream" data-id="element-186" data-mp="2j08ieal7s750">{tool.name}</h3>
              <p className="mt-3 text-base leading-relaxed text-cream/65" data-id="element-187" data-mp="2nu4bozqj95tu">{tool.body}</p>
              <a href="#top" className="group mt-auto inline-flex items-center gap-2 pt-7 text-sm font-semibold text-brand-green transition-colors duration-150 ease-out hover:text-cream" data-id="element-188" data-mp="2p276422mhnll">
                {tool.cta}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-189" data-mp="2u08t2y36672c" />
              </a>
            </article>)}
        </div>
      </div>
    </section>;
}